// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3mudW","label":"Labeled_label__3KDMf","divider":"Labeled_divider__aO45-"};